import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { CustomValidators } from '../../../shared/validators/custom-validators';
import { CommonModule } from '@angular/common';
import { BidderCommunityMenuService } from '../../../services/bidder-community/bidder-community-menu/bidder-community-menu.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule, Router } from '@angular/router';
import { PasswordModule } from 'primeng/password';
import { IPasswordRequest } from '../../../models/IPasswordRequest';
import { AuthService } from '../../../services/authentication/auth.service';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../../../environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { distinctUntilChanged, Subscription } from 'rxjs';




@Component({
  selector: 'app-password',
  imports: [FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CommonModule,
    FontAwesomeModule,
    PasswordModule,
    ProgressSpinnerModule,
    RouterModule],
  templateUrl: './password.component.html',
  styleUrl: './password.component.scss'
})
export class PasswordComponent implements OnInit {

  @Input() id!: number;
  public faInfoCircle = faInfoCircle;
  isValidOldPassword: boolean = true;
  isLoading: boolean = false;

  private readonly bidderCommunityMenuService = inject(BidderCommunityMenuService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly authService = inject(AuthService);
  private readonly messageService = inject(ToastMessageService);
  private readonly router = inject(Router);
  isAuthenticated = this.oidcSecurityService.authenticated;
  authSubscription!: Subscription;

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      oldPassword: ['', [CustomValidators.required('Current Password')]],
      password: ['', [CustomValidators.required('New Password'), CustomValidators.passwordValidator('New Password')]]
    });

  }

  ngOnInit(): void {
    setTimeout(() => {
      this.bidderCommunityMenuService.setPageData(
        {
          id: this.id!,
          pageName: "Password",
          pageRoute: "password"
        }
      )

      if (typeof window !== 'undefined') {
        window.onpageshow = function (event) {
          if (event.persisted) {
            window.location.reload();
          }
        };
        if (!this.isAuthenticated().isAuthenticated) {
          window.open(environment.mediaUrl, '_self');
          return
        }
      }
      this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
        if (!isAuth){
            if (typeof window !== 'undefined') {
              window.open(environment.mediaUrl, '_self');
            }
            return;
        }
      });
    },100);

    this.form.controls['oldPassword'].valueChanges.subscribe(() => {
      this.isValidOldPassword = true;
    })
  }

  getFieldError(field: string): string | null {

    const control = this.form.get(field);
    if (control && control.errors && (control.dirty || control.touched)) {
      const firstErrorKey = Object.keys(control.errors)[0];
      return control.errors[firstErrorKey];
    }
    return null;
  }

  onSubmit() {

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }


    const formData: IPasswordRequest = this.form.getRawValue();


    this.authService.patchPassword(formData).subscribe({
      next: () => {

        this.messageService.success(`Your password has been updated successfully.`);
        this.isLoading = true;
        setTimeout(() => {

          this.router.navigate(['/my-account', this.id]);
          this.isLoading = false;
        }, 3500);



      },
      error: (err) => {
        let errorMsg = 'unknown error';

        console.log(err, 'err');

        if (err.error) {
          if (typeof err.error === 'string') {
            try {
              const parsed = JSON.parse(err.error);
              errorMsg = parsed.message || errorMsg;
            } catch {
              errorMsg = err.error;
            }
          }
          else if (typeof err.error === 'object') {
            errorMsg = err.error.message
              || err.error.errorMessage
              || errorMsg;
          }
        }

        if (errorMsg === 'Invalid old password') {
          this.isValidOldPassword = false;
          // this.messageService.error(errorMsg || 'unknown error');
        }
      }
    })

  }

}
